import CustomTable from "@/components/table/CustomTable"
import { formTable } from "@/interface/dataInterface"
import { FC } from "react"

const VoipTable: FC<formTable> = ({data, setData}) => {
    return (
        <CustomTable 
            data={data}
            setData={setData}
            columns={["User", "Username", "Password"]}
            leadProp="firstname"
            secondProp="lastname"
            otherProps={[{prop: "extension_id", type: "text"}, {prop: "password", type: "password"}]}
        />
    )
}

export default VoipTable